import NavBarLogo from 'shared/components/atoms/NavBarLogo/NavBarLogo';

export default NavBarLogo;
